import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { savePriceMatrix, getPriceMatrix, getWeightSettings, getTaxesRate } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { initializePriceMatrixForm, clearFormInput } from 'actions/FormActions';
import { selectPriceMatrixModel } from 'selectors/entitySelector';
import TextInput from 'screens/components/basic/TextInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import PriceMatrixMeasurementTable from './PriceMatrixMeasurementTable';
import LOOKUP from 'constants/lookup';
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';
import { priceMatrixEditCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';

class PriceMatrixSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            status: null
        };
    }

    // control if is ADD or EDIT
    componentWillMount() {
        // get all weightSettings
        this.props.getWeightSettings();
        this.props.getTaxesRate();

        const priceMatrixId = this.props.params ? this.props.params.id : 0;
        // if true dispatch an action to retrive data from API and set Status to EDIT
        if (priceMatrixId) {
            this.setState({ status: "EDIT" });
            this.props.getPriceMatrix(priceMatrixId);
        }
        // if false dispatch an action to clean the form and set default values and set Status to ADD
        else {
            this.setState({ status: "ADD" });
        }
    }

    // is SUCCEEDED or FAILED
    // check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)) {
            // if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else {
                this.saveFailure(newProps.saveError);
                this.props.clearFormInput('priceMatrixSaveSaveSuccess');
            }

        }
    }

    componentWillUnmount = () => {
        this.props.init();
        this.props.clearFormInput('CalcTaxRateGST');
        this.props.clearFormInput('CalcTaxRatePST');
    }

    // when data is saved successfully
    saveSuccess = () => {
        this.redirectToListPriceMatrices();
        this.props.showSuccess(this.state.status === "EDIT" ? LOOKUP.priceMatrix.messages.editedMessage : LOOKUP.priceMatrix.messages.createdMessage);
    }

    // when data is not saved, failure
    saveFailure = (saveError) => {
        this.props.showError(saveError);
    }

    calculateTax = (priceMatrix) => {

        if (this.props.GST && !!this.props.PST === false) {
            const { rate } = this.props.taxes.filter(t => t.name === "GST")[0];

            return priceMatrix.PriceMatrixDetails.map(m => {
                return {
                    ...m,
                    MemberPrice: (m.MemberPrice * (100 / (100 + (rate * 100)).toFixed(4))).toFixed(2),
                    Price: (m.Price * (100 / (100 + (rate * 100)).toFixed(4))).toFixed(2)
                };
            });
        }

        if (this.props.PST && !!this.props.GST === false) {
            const { rate } = this.props.taxes.filter(t => t.name === "PST")[0];

            return priceMatrix.PriceMatrixDetails.map(m => {
                return {
                    ...m,
                    MemberPrice: (m.MemberPrice * (100 / (100 + (rate * 100)).toFixed(4))).toFixed(2),
                    Price: (m.Price * (100 / (100 + (rate * 100)).toFixed(4))).toFixed(2)
                };
            });
        }

        if (this.props.PST && this.props.GST) {
            const pst = Math.round(this.props.taxes.filter(t => t.name === "PST")[0].rate * 100);
            const gst = Math.round(this.props.taxes.filter(t => t.name === "GST")[0].rate * 100);

            return priceMatrix.PriceMatrixDetails.map(m => {
                return {
                    ...m,
                    MemberPrice: (m.MemberPrice * (100 / (100 + (gst + pst))).toFixed(4)).toFixed(2),
                    Price: (m.Price * (100 / (100 + (gst + pst))).toFixed(4)).toFixed(2)
                };
            });
        }
        return priceMatrix.PriceMatrixDetails;
    }

    savePriceMatrix = () => {
        //PriceMatrix is a Object with BranchId, Id, Name, Status, and PriceMAtrixDetails
        const priceMatrix = this.props.priceMatrixModel;
        priceMatrix.PriceMatrixDetails = this.calculateTax(priceMatrix);
        this.props.savePriceMatrix(priceMatrix);
    }

    redirectToListPriceMatrices = () => {
        this.props.navigate("/priceMatrix");
    }

    render() {
        const p = this.props;
        const measurements = (p.measurementSettings || []).filter(item => item.status == "Active");
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to={LOOKUP.menu.inventory.items.priceMatrix.link}>{LOOKUP.menu.inventory.items.priceMatrix.text}</Link></li>
                    <li className="active">{LOOKUP.priceMatrix.titles.manage}</li>
                </ol>
                <h2>{LOOKUP.priceMatrix.titles.manage} <Button type="HeaderBackPage" onTouchTap={() => this.redirectToListPriceMatrices()} /></h2>
            </div>);

        return (
            <Grid headerContent={priceMatrixEditCrumb}>
                <PageHeader title="Manage Price Matrix" />
                <CardSimple title="Price Matrix Info" className="paddingForMobileDevices">
                    <div className="row">
                        {
                            this.state.status === "EDIT" ?
                                (
                                    <div className="col-lg-12">
                                        <TextInput
                                            name={p.name + "Id"}
                                            label={LOOKUP.priceMatrix.id.label}
                                            hintText={LOOKUP.priceMatrix.id.hintText}
                                            disabled={true}
                                            fullWidth={true} />
                                    </div>
                                ) : null
                        }
                        <div className="col-lg-8">
                            <TextInput name={`${p.name}Name`}
                                fullWidth={true}
                                floatingLabelText={LOOKUP.priceMatrix.name.label}
                                label={LOOKUP.priceMatrix.name.label}
                                hintText={LOOKUP.priceMatrix.name.hintText}
                                maxLength={50}
                                required />
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                            <ToggleInput className="price_matrix_status btnToggleLabel" name={`${p.name}Status`} label={LOOKUP.priceMatrix.status.label} />
                        </div>
                    </div>
                </CardSimple>
                <br />
                <CardSimple title="Settings Info" className="paddingForMobileDevices">
                    <div className="row">
                        <div className="col-lg-12">
                            {
                                this.state.status == "EDIT"
                                    ?
                                    <PriceMatrixMeasurementTable name={`${p.name}Details`} measurementSettings={measurements} hideEmpty={false} isMedical={p.isMedical} />
                                    :
                                    <PriceMatrixMeasurementTable name={`${p.name}Details`} measurementSettings={measurements} hideEmpty={false} notPrintLabel={true} isMedical={p.isMedical} />
                            }

                        </div>
                    </div>
                </CardSimple>
                <br />
                <div className="row marginRightMobile">
                    <div className="col-lg-12">
                        <Button
                            name="saveButton"
                            className="pull-right btnNewBrandPOS"
                            label={LOOKUP.priceMatrix.controls.saveButton}
                            primary={true}
                            onTouchTap={() => this.savePriceMatrix()} />
                        <Button
                            type="CancelButton"
                            name="buttonCancel"
                            className="pull-right btn-space btnCancelOperation"
                            label={LOOKUP.priceMatrix.controls.cancelButton}
                            onTouchTap={() => this.redirectToListPriceMatrices()} />
                    </div>
                </div>
            </Grid>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        measurementSettings: state.entity.weightSettingsList,
        priceMatrixModel: selectPriceMatrixModel(state, ownProps.name),
        saveSuccess: state.form[ownProps.name + "SaveSuccess"],
        saveError: state.form[ownProps.name + "SaveError"],
        taxes: state.entity.taxesrateList.filter(t => t.status != 2),
        GST: state.form.CalcTaxRateGST,
        PST: state.form.CalcTaxRatePST,
        isMedical: state.common.applicationSettings.isMedical
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        getWeightSettings: () => dispatch(getWeightSettings()),
        getPriceMatrix: (id) => dispatch(getPriceMatrix(id, ownProps.name)),
        savePriceMatrix: (model) => dispatch(savePriceMatrix(model, ownProps.name)),
        init: () => dispatch(initializePriceMatrixForm(ownProps.name)),
        showError: (message) => dispatch(showError(message)),
        showSuccess: (message) => dispatch(showSnackbar(message)),
        getTaxesRate: () => dispatch(getTaxesRate(1)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(PriceMatrixSave));